async function initMap() {

  if( document.querySelector('#map') ) {
    const { Map } = await google.maps.importLibrary("maps");
    const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");
    const center = { lat: 21.736340700348755, lng: 39.2623853563887 };
    const map = new Map(document.getElementById("map"), {
      zoom: 2.8,
      center,
      mapId: "21acb0babf3d8f75"
    });
    const icon_t = '<svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50"><path d="M15.31 7.55c-2.52 0-4.58 2.05-4.58 4.58v3.34h10.02v25.59c0 .34.27.61.61.61s.61-.28.61-.61V35.1c0-.34.27-.61.61-.61s.61.28.61.61l-.03 6.73c0 .34.28.61.61.61s.61-.28.61-.61l-.02-6.73c0-.34.28-.61.61-.61s.61.28.61.61v6.73c-.01.34.26.61.6.61s.61-.28.61-.61l-.03-6.73c0-.34.28-.61.61-.61s.61.28.61.61v5.96c0 .34.27.61.61.61s.61-.28.61-.61V15.47h5.67c2.4 0 4.35-1.95 4.35-4.35V7.55H15.31Z" fill="#fff"/></svg>';
    const icon_p = '<svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50"><path d="M24.85 7.52H12.46v33.57c0 .34.27.61.61.61s.61-.28.61-.61v-5.96c0-.34.27-.61.61-.61s.61.28.61.61l-.03 6.73c0 .34.28.61.61.61s.61-.28.61-.61l-.02-6.73c0-.34.28-.61.61-.61s.61.28.61.61v6.73c-.01.34.26.61.6.61s.61-.28.61-.61l-.03-6.73c0-.34.28-.61.61-.61s.61.28.61.61v5.96c0 .34.27.61.61.61s.61-.28.61-.61V30.91h3.9c7.44 0 12.7-3.84 12.7-11.65S32.25 7.52 24.81 7.52Zm-1.34 16.05h-2.57v-8.69h2.57c3.76 0 4.89 1.46 4.89 4.39s-1.13 4.3-4.89 4.3Z" fill="#fff"/></svg>';
    const icon_globe = '<svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50"><path d="M25 7.76C15.48 7.76 7.76 15.48 7.76 25S15.48 42.24 25 42.24 42.24 34.52 42.24 25 34.52 7.76 25 7.76Zm3.35 30.28-.86-.2-2.45-.3-3 .6c-2.9-.65-5.45-2.23-7.31-4.42l-.41-1.91.74-4.61-2.16-.89-.15-1.56-1.13-1.39c.4-3.31 2-6.24 4.36-8.36l1.81-.17 1.78-2.15c1.66-.73 3.49-1.15 5.43-1.15s3.66.38 5.28 1.08l-4.86 1.8h-.02l-.44.16.31.28-.39 1.41-1.56.3.52.74 2.65-1.35 1.93 1.74-.78 1.45-2.01-1.67-2.9.67-2.34 4.13 1.56 2.9 4.69.78 2.01 8.26 5.02-4.35-.11-3.57 1.79-.67.11-2.79 1.45-1.56-1.45-1.67 2.08.5c.6 1.52.93 3.17.93 4.9 0 6.28-4.31 11.54-10.12 13.04Z"/></svg>';
    const icon_phone = '<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50"><defs><style>.cls-1{fill:#fff}</style></defs><path class="cls-1" d="M32.65 5.68h-15.3c-1.14 0-2.23.45-3.03 1.25-.8.8-1.25 1.89-1.25 3.03v30.07c0 1.14.45 2.23 1.25 3.03.8.8 1.89 1.25 3.03 1.25h15.3c1.14 0 2.23-.45 3.03-1.25.8-.8 1.25-1.89 1.25-3.03V9.96c0-1.14-.45-2.23-1.25-3.03-.8-.8-1.89-1.25-3.03-1.25Zm1.09 34.36c0 .29-.12.57-.32.77-.2.2-.48.32-.77.32h-15.3c-.29 0-.57-.12-.77-.32-.2-.2-.32-.48-.32-.77V9.96c0-.29.12-.57.32-.77s.48-.32.77-.32h15.3c.29 0 .57.12.77.32s.32.48.32.77v30.07Z"/><path class="cls-1" d="M28.1 36.7h-6.2a1.606 1.606 0 0 0-1.6 1.6c0 .43.17.83.47 1.13.3.3.7.47 1.13.47h6.2a1.606 1.606 0 0 0 1.6-1.6c0-.43-.17-.83-.47-1.13-.3-.3-.7-.47-1.13-.47Z"/></svg>';
    const icon_mail = '<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50"><defs><style>.cls-1{fill:#fff}</style></defs><path class="cls-1" d="M39.72 15.66v12.51c0 5.01-1.23 6.64-5.55 6.64h-23.5V15.66h29.05m1.35-3.18H9.31c-1 0-1.82.82-1.82 1.82v21.85c0 1 .82 1.82 1.82 1.82h26.84c3.8 0 6.73-2.73 6.73-7.74V14.3c0-1.01-.82-1.83-1.82-1.83Z"/><path class="cls-1" d="M25.35 28.9c-.41 0-.79-.16-1.09-.44l-9.79-7.42a1.488 1.488 0 0 1 0-2.4c.6-.46 1.48-.46 2.1 0l8.78 6.71 8.78-6.71a1.77 1.77 0 0 1 2.1 0c.39.3.61.73.61 1.2s-.21.9-.59 1.2l-.01.01-9.91 7.52c-.19.19-.57.35-.97.35Zm-9.44-9.76Z"/></svg>';
    const icon_pin = '<svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50"><path d="M25 6.8h12.27v12.27C37.27 25.84 25 43.21 25 43.21S12.73 25.85 12.73 19.07 18.22 6.8 25 6.8Zm0 17.69c2.99 0 5.42-2.43 5.42-5.42v-5.42H25c-2.99 0-5.42 2.43-5.42 5.42s2.43 5.42 5.42 5.42Z"/></svg>';

    for (const map_item of map_items) {
      let icon = ( map_item.type == 'port' ) ? icon_p : icon_t;
      const AdvancedMarkerElement = new google.maps.marker.AdvancedMarkerElement({
        map,
        content: buildContent(map_item, icon, icon_globe, icon_mail, icon_phone, icon_pin),
        position: {
          lat: map_item.position_lat, 
          lng: map_item.position_lng
        },
        title: map_item.description,
      });
  
      AdvancedMarkerElement.addListener("click", () => {
        toggleHighlight(AdvancedMarkerElement, map_item);
      });
    }
    map.addListener("click", () => {
      document.querySelectorAll('.map_item.highlight').forEach( element => {
        element.classList.remove("highlight");
      });
    });
  }
    
}
  
function toggleHighlight(markerView, map_item) {
    if (markerView.content.classList.contains("highlight")) {
      markerView.content.classList.remove("highlight");
      markerView.zIndex = null;
    } else {
      markerView.content.classList.add("highlight");
      markerView.zIndex = 1;
    }
}
  
function buildContent(map_item, icon, icon_globe, icon_mail, icon_phone, icon_pin) {
    const content = document.createElement("div");

    content.classList.add("map_item");
    content.innerHTML = `
      <div class="icon ${map_item.type}">
          ${icon}
      </div>
      <div class="details ${map_item.type}">
          <div class="name">${map_item.name}</div>
          <div class="country">${map_item.country}</div>
          <a target="_blank" href="mailto:${map_item.email}">${icon_mail}<span>${map_item.email}</span></a>
          <a target="_blank" href="tel:${map_item.phone}">${icon_phone}<span>${map_item.phone}</span></a>
          <a target="_blank" href="${map_item.website}">${icon_globe}<span>${map_item.website_nice}</span></a>
          <a target="_blank" href="https://www.google.com/maps/search/?api=1&query=${map_item.position_lat}%2C${map_item.position_lng}">${icon_pin}<span>${map_item.address}</span></a>
      </div>
      `;
    return content;
}
  
var request = new XMLHttpRequest();
request.open("GET", "/wp-content/themes/trelawny-2025/assets/map-data.json", false);
request.send(null);
const map_items = JSON.parse(request.responseText);


initMap();